export class AlertLifecycleError extends Error {
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = 'AlertLifecycleError';
    }
}
const LEVEL_ALIASES = {
    normal: 'normal',
    ok: 'normal',
    debug: 'normal',
    advisory: 'advisory',
    info: 'advisory',
    caution: 'caution',
    warning: 'warning',
    critical: 'warning',
};
const LEVEL_PRIORITY = {
    normal: 0,
    advisory: 1,
    caution: 2,
    warning: 3,
};
export function normalizeAlertLevel(level) {
    const input = typeof level === 'string' ? level.trim().toLowerCase() : '';
    const normalized = LEVEL_ALIASES[input];
    if (!normalized) {
        throw new AlertLifecycleError('alert-level-invalid', `unsupported alert level: ${String(level)}`);
    }
    return normalized;
}
export function alertPriority(level) {
    return LEVEL_PRIORITY[normalizeAlertLevel(level)];
}
export function orderAlerts(alerts) {
    return alerts
        .map((alert, index) => ({ alert, index, priority: alertPriority(alert.level) }))
        .sort((left, right) => {
        if (left.alert.acknowledged !== right.alert.acknowledged) {
            return left.alert.acknowledged ? 1 : -1;
        }
        const priorityDelta = right.priority - left.priority;
        return priorityDelta !== 0 ? priorityDelta : left.index - right.index;
    })
        .map(({ alert }) => alert);
}
export function reconcileAcknowledgements(activeIds, acknowledgedIds) {
    const active = new Set(activeIds);
    const retained = new Set();
    for (const id of acknowledgedIds) {
        if (active.has(id))
            retained.add(id);
    }
    return [...retained];
}
export function highestAlertLevel(alerts, includeAcknowledged = false) {
    let highest = 'normal';
    let highestPriority = LEVEL_PRIORITY.normal;
    for (const alert of alerts) {
        const level = normalizeAlertLevel(alert.level);
        if (!includeAcknowledged && alert.acknowledged)
            continue;
        const priority = LEVEL_PRIORITY[level];
        if (priority > highestPriority) {
            highest = level;
            highestPriority = priority;
        }
    }
    return highest;
}
//# sourceMappingURL=alerts.js.map